export default __webpack_public_path__ + "static/media/zip.9509c525.svg";